<script setup lang="ts">
import { inject, onMounted, ref } from "vue";
import { TabBoxConfigInjectionKey } from "../../helpers.js";
import Copy from "../../atoms/Copy/Copy.vue";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },

  byline: {
    type: String,
    default: "",
  },

  active: {
    type: Boolean,
    default: false,
  },

  autoFocusDisable: {
    type: Boolean,
    default: false,
  },
});

const button = ref<HTMLButtonElement>();

const tabBoxConfig = inject(TabBoxConfigInjectionKey)!;

onMounted(() => {
  if (props.active && props.autoFocusDisable) button.value?.focus();
});
</script>

<template>
  <button
    ref="button"
    v-bind="$attrs"
    :class="[
      'tab-box-item',
      tabBoxConfig.v2activeMode ? $style.containerV2 : $style.container,
      $style[active ? 'active' : ''],
    ]"
    :style="{
      '--tab-box-item-color-hover': `var(${tabBoxConfig.colorBackgroundHover})`,
      'background-color': `var(${
        active && !tabBoxConfig.v2activeMode
          ? tabBoxConfig.colorBackgroundActive
          : '--color-transparent'
      })`,
      'border-bottom': `var(${
        active ? tabBoxConfig.colorBackgroundActive : '--color-transparent'
      }) ${tabBoxConfig.v2activeMode ? '0.25rem' : '0'} solid`,
    }"
  >
    <Copy
      type="body"
      size="small"
      :color="
        active && !tabBoxConfig.v2activeMode
          ? tabBoxConfig.colorLabelActive
          : tabBoxConfig.colorLabelInactive
      "
    >
      <strong v-if="!tabBoxConfig.v2activeMode || active">{{ label }}</strong>

      <span v-else>{{ label }}</span>

      <span v-if="byline !== ''" :class="$style.byline">{{ byline }}</span>
    </Copy>
  </button>
</template>

<style module>
.container {
  display: inline-flex;
  padding: 0.25rem 1rem;
  margin: 0 0.25rem;
  cursor: pointer;
  appearance: none;
  outline: none;
  clip-path: inset(0 0 0 0 round var(--border-radius-medium));
  border-style: none;
  font: inherit;
}

.container:not(.active):hover {
  /* NOTE: cllpse: important because the background-color is set on the element directly */
  background-color: var(--tab-box-item-color-hover) !important;
}

.containerV2:not(.active):hover {
  /* NOTE: cllpse: important because the background-color is set on the element directly */
  border-bottom: 0.25rem var(--tab-box-item-color-hover) solid !important;
}

.containerV2 {
  display: inline-flex;
  padding: 0.25rem 1rem 0rem 1rem;
  margin: 0 0.25rem;
  cursor: pointer;
  appearance: none;
  outline: none;
  border-style: none;
  font: inherit;
}

.byline {
  opacity: 0.7;
  margin-left: 0.25rem;
}

/* .container.active {
  margin-left: 1rem;
  margin-right: 1rem;
}

.container:first-child:not(.active) {
  margin-left: 0.5rem;
}

.container:last-child:not(.active) {
  margin-right: 0.5rem;
}

.container:first-child.active {
  margin-left: unset;
}

.container:last-child.active {
  margin-right: unset;
} */
</style>
